import * as tg from "generic-type-guard";

import { assertNonNullable, assertTrue } from "./assert";

export const isProcessDefinitionKey = new tg.IsInterface()
	.withProperties({
		fachverfahrenId: tg.isString,
		bpmnKey: tg.isString
	})
	.get();

export type ProcessDefinitionKey = tg.GuardedType<typeof isProcessDefinitionKey>;

export const ProcessDefinitionKey = {
	toString(processDefinitionKey: ProcessDefinitionKey): string {
		return `${processDefinitionKey.fachverfahrenId}_${processDefinitionKey.bpmnKey}`;
	},
	fromString(key: string): ProcessDefinitionKey {
		const [fachverfahrenId, bpmnKey, ...rest] = key.split("_");
		assertNonNullable(fachverfahrenId);
		assertNonNullable(bpmnKey);
		assertTrue(rest.length === 0);

		return { fachverfahrenId, bpmnKey };
	}
};
